module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/masters/customer-risk-analysis-grid/customer-risk-analysis-grid.component.css
// module id = ./src/app/masters/customer-risk-analysis-grid/customer-risk-analysis-grid.component.css
// module chunks = main